<template>
<svg t="1717040638423" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="58494" width="32" height="32"><path d="M96 448v320a96.288 96.288 0 0 0 96 96h640a96.288 96.288 0 0 0 96-96V448z m529.28 209.28a33.344 33.344 0 0 1-22.72 9.28 32.768 32.768 0 0 1-22.72-9.28L544 621.12V768a32 32 0 0 1-64 0v-146.88l-35.84 36.16a32 32 0 0 1-45.44-45.44l90.56-90.56a31.616 31.616 0 0 1 10.24-6.72 11.872 11.872 0 0 1 4.48-1.28 25.6 25.6 0 0 1 16 0 11.872 11.872 0 0 1 4.48 1.28 31.616 31.616 0 0 1 10.24 6.72l90.56 90.56a32.256 32.256 0 0 1 0 45.44zM928 352v32H96V256a96.288 96.288 0 0 1 96-96h223.36a32.768 32.768 0 0 1 26.56 14.08L496.96 256H832a96.288 96.288 0 0 1 96 96z" p-id="58495" fill="#FFC500"></path></svg>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>